import {
  Button,
  IconButton,
  Spacer,
  SvgClose,
  SvgMobileDevices,
  Text,
} from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LARGE_TABLET_MIN_WIDTH } from 'constants/breakpoints';
import {
  CONTINUE_WATCHING_DISMISSED,
  CONTINUE_WATCHING_DOWNLOAD_TAPPED,
  CONTINUE_WATCHING_SHOWN,
} from 'constants/events';
import { MOBILE_WEB } from 'constants/routes';
import { SHOW_CONTINUE_WATCHING_BANNER } from 'constants/triggers';
import { completeTriggerCreator } from 'creators/triggers';
import {
  selectHasEnded,
  selectHasStarted,
  selectPaused,
} from 'selectors/videoPlayer';
import * as analytics from 'utilities/analytics';

import { useShowContinueWatchingBanner } from 'hooks/banners';
import { useUrlTriggerReset } from 'hooks/triggers';

import MediaQuery from 'components/media-query';

import styles from './styles.module.less';

const ContinueWatchingMobileBanner = () => {
  const shouldLoadBanner = useShowContinueWatchingBanner();

  useUrlTriggerReset({
    paramName: 'resetContinueWatching',
    trigger: SHOW_CONTINUE_WATCHING_BANNER,
  });

  if (!shouldLoadBanner) {
    return null;
  }

  return <ContinueWatchingBase />;
};

const ContinueWatchingBase = () => {
  const dispatch = useDispatch();
  const hasStarted = useSelector(selectHasStarted);
  const ended = useSelector(selectHasEnded);
  const paused = useSelector(selectPaused);

  const renderBanner = hasStarted && !ended;
  const bannerIsVisible = paused;

  useEffect(() => {
    if (renderBanner && bannerIsVisible) {
      analytics.track(CONTINUE_WATCHING_SHOWN);
    }
  }, [renderBanner, bannerIsVisible]);

  if (!renderBanner) {
    return null;
  }

  return (
    <MediaQuery query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}>
      <div
        className={classNames(styles.container, bannerIsVisible && styles.show)}
      >
        <Text fontWeight="book">Continue watching on mobile</Text>
        <Spacer right="medium" />
        <Button
          variant="primary"
          icon={<SvgMobileDevices />}
          onClick={() => {
            const newTab = window.open(
              MOBILE_WEB,
              '_blank',
              'noopener,noreferrer'
            );

            if (newTab) {
              newTab.opener = null;
            }

            analytics.track(CONTINUE_WATCHING_DOWNLOAD_TAPPED);
          }}
        >
          Download
        </Button>
        <Spacer right="xsmall" />
        <IconButton
          altText="Close"
          icon={<SvgClose />}
          onClick={() => {
            dispatch(completeTriggerCreator(SHOW_CONTINUE_WATCHING_BANNER));
            analytics.track(CONTINUE_WATCHING_DISMISSED);
          }}
        />
      </div>
    </MediaQuery>
  );
};

export default ContinueWatchingMobileBanner;
